import { render } from "./ReorderModal.vue?vue&type=template&id=037116c9&scoped=true"
import script from "./ReorderModal.vue?vue&type=script&lang=js"
export * from "./ReorderModal.vue?vue&type=script&lang=js"

import "./ReorderModal.vue?vue&type=style&index=0&id=037116c9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037116c9"]])

export default __exports__